module.exports = __webpack_public_path__ + "r-v3/img/translation_RU.ad27b032.png";